import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';
import KnowledgeBaseContentLibrary from '../../containers/KnowledgeBase/KnowledgeBaseContentLibrary/KnowledgeBaseContentLibrary';
import PocPage from '../../clubhouse/poc-page/poc-page';
import { DataRequestDashboardPage } from '../../containers/DataRequest/DataRequestDashboardPage/DataRequestDashboardPage';
const GrowPage = lazy(() => import('../../venues/pages/GrowPage/GrowPage'));
const MyPractices = lazy(() => import('../../containers/Practices/MyPractices'));
const Practice = lazy(() => import('../../containers/Practices/Practice'));
const PracticeManagement = lazy(() => import('../../containers/PracticeManagementGroups/PracticeManagement'));
const PracticeManagementPMG = lazy(() => import('../../containers/PracticeManagementGroups/PracticeManagementPMG/PracticeManagementPMG'));
const MyGroupsAdminComponant = lazy(() => import('../../containers/MyGroups/MyGroups'));
const PracticeValuationReports = lazy(() => import('../../containers/PracticeValuationReports/PracticeValuationReports'));

export const GROW_ROUTES: AppRoute[] = [
    { path: '', element: <GrowPage /> },
    { path: 'practices', element: <MyPractices /> },
    { path: 'practices/:id', element: <Practice /> },
    { path: 'knowledge-library', element: <KnowledgeBaseContentLibrary />, withAppShell: true },
    { path: 'practice-management-groups', element: <PracticeManagement /> },
    { path: 'practice-management-pmg/:id', element: <PracticeManagementPMG /> },
    { path: 'my-groups', element: <MyGroupsAdminComponant /> },
    { path: 'ipoc', element: <PocPage />, withAppShell: true },
    { path: 'cpoc/:id', element: <PocPage />, withAppShell: true },
    { path: 'practice-valuation-reports', element: <PracticeValuationReports /> },
    { path: 'data-request-dashboard', element: <DataRequestDashboardPage /> },
    { path: 'data-request-dashboard/others', element: <DataRequestDashboardPage /> },
];
